import React from "react";
import PropTypes from "prop-types";
import { Form, Button } from "antd";
import { FormattedMessage } from "react-intl";
import FormActionsWrapper from "./FormActions.style";

const ModalActions = (props) => {
  const {
    onDecline,
    loading,
    hidePrimary,
    hideDecline,
    declineTitle,
    approveTitle,
    disabled,
  } = props;

  return (
    <FormActionsWrapper className="modalActions">
      <Form.Item>
        {hideDecline ? null : (
          <Button
            style={{ margin: "0 10px" }}
            htmlType="button"
            onClick={onDecline}
          >
            {declineTitle ? (
              declineTitle
            ) : (
              <FormattedMessage id="app.actions.decline" />
            )}
          </Button>
        )}
        {hidePrimary ? null : (
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            disabled={disabled}
          >
            {approveTitle ? (
              approveTitle
            ) : (
              <FormattedMessage id="app.actions.submit" />
            )}
          </Button>
        )}
      </Form.Item>
    </FormActionsWrapper>
  );
};

ModalActions.propTypes = {
  onDecline: PropTypes.func,
  loading: PropTypes.bool,
  hidePrimary: PropTypes.bool,
  hideDecline: PropTypes.bool,
  declineTitle: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  approveTitle: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  disabled: PropTypes.bool,
};

export default ModalActions;
